import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  & > :not(:last-child) {
    margin-right: 8px;
  }
`;
